export const REDUCER_KEY = 'match'

export const ENTITY_TYPE_TRANSACTION = 'transaction'
export const ENTITY_TYPE_TRANSACTION_DIRECT_DEBIT_RETURN = 'transaction.directDebitReturn'

export const MATCH_GROUP_PAYMENT = 'PAYMENT'
export const MATCH_TYPE_PAYMENT_FUNDS_TRANSFER = 'FUNDS_TRANSFER'
export const MATCH_TYPE_PAYMENT_REPAYMENT = 'REPAYMENT'
export const MATCH_TYPE_PAYMENT_DD_RETURN = 'MT.PAYMENT_DD_RETURN'
export const MATCH_TYPE_PAYMENT_PASS_THROUGH = 'MT.PAYMENT_PASS_THROUGH'

export const MATCH_GROUP_INVOICE = 'INVOICE'
export const MATCH_TYPE_INVOICE_FUNDS_TRANSFER = 'MT.INVOICE_FUNDS_TRANSFER'
export const MATCH_TYPE_INVOICE_REPAYMENT = 'MT.INVOICE_REPAYMENT'
export const MATCH_TYPE_INVOICE_DD_RETURN = 'MT.INVOICE_DD_RETURN'

export const sourceTypes = [ENTITY_TYPE_TRANSACTION, ENTITY_TYPE_TRANSACTION_DIRECT_DEBIT_RETURN]
export const matchTypes = [
  MATCH_TYPE_INVOICE_REPAYMENT,
  MATCH_TYPE_INVOICE_FUNDS_TRANSFER,
  MATCH_TYPE_INVOICE_DD_RETURN,
  MATCH_TYPE_PAYMENT_REPAYMENT,
  MATCH_TYPE_PAYMENT_FUNDS_TRANSFER,
  MATCH_TYPE_PAYMENT_DD_RETURN,
]
export const matchGroups = [MATCH_GROUP_PAYMENT, MATCH_GROUP_INVOICE]

export const TRANSACTION_TYPE_INVOICE_FUNDS_TRANSFER = 'INVOICE_FUNDS_TRANSFER'
export const TRANSACTION_TYPE_INVOICE_REPAYMENT = 'INVOICE_REPAYMENT'

export const matchGroupOptions = [
  {
    matchGroup: MATCH_GROUP_PAYMENT,
    label: 'Funds Transfer / Repayment',
  },
  {
    matchGroup: MATCH_GROUP_INVOICE,
    label: 'Invoice Funds Transfer / Invoice Repayment',
  },
]

export const matchEntityLabels = {
  [ENTITY_TYPE_TRANSACTION]: 'Transaction',
  [ENTITY_TYPE_TRANSACTION_DIRECT_DEBIT_RETURN]: 'Transaction Direct Debit Return',
}

export const BULK_MATCHING_COMMENT = 'Split using bulk matching'
